import baseStyles from './base'
import oliveStyles from './olive'

export default {
  base: baseStyles,
  olive: oliveStyles,
}
